import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
};

export type AdServiceInfo = {
  __typename?: 'AdServiceInfo';
  adServiceMaxPlayTime?: Maybe<Scalars['Int']['output']>;
  adServiceOptions?: Maybe<Array<AdServiceOption>>;
  adServiceTimeFrom?: Maybe<Scalars['String']['output']>;
  adServiceTimeTo?: Maybe<Scalars['String']['output']>;
  allDay247?: Maybe<Scalars['Boolean']['output']>;
  dailyMinImpressions?: Maybe<Scalars['Int']['output']>;
  friday?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  monday?: Maybe<Scalars['Boolean']['output']>;
  saturday?: Maybe<Scalars['Boolean']['output']>;
  slot?: Maybe<Scalars['Int']['output']>;
  sunday?: Maybe<Scalars['Boolean']['output']>;
  thursday?: Maybe<Scalars['Boolean']['output']>;
  tuesday?: Maybe<Scalars['Boolean']['output']>;
  wednesday?: Maybe<Scalars['Boolean']['output']>;
};

export type AdServiceOption = {
  __typename?: 'AdServiceOption';
  adFee?: Maybe<Scalars['Float']['output']>;
  adFeeCurrency?: Maybe<Scalars['String']['output']>;
  adFeePerMonth?: Maybe<Scalars['Float']['output']>;
  adPlayTime?: Maybe<Scalars['Int']['output']>;
  adType?: Maybe<Scalars['String']['output']>;
  commercialPeriod?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isDefaultOption?: Maybe<Scalars['Boolean']['output']>;
};

export enum AgeGroup {
  A30S = 'A30S',
  A40S = 'A40S',
  A50S = 'A50S',
  A60S = 'A60S',
  A70S = 'A70S',
  R10_14 = 'R10_14',
  R15_19 = 'R15_19',
  R20_24 = 'R20_24',
  R25_29 = 'R25_29'
}

export type Bounds = {
  east?: InputMaybe<Scalars['Float']['input']>;
  north?: InputMaybe<Scalars['Float']['input']>;
  south?: InputMaybe<Scalars['Float']['input']>;
  west?: InputMaybe<Scalars['Float']['input']>;
};

export enum Gender {
  Female = 'FEMALE',
  Male = 'MALE'
}

export type Media = {
  __typename?: 'Media';
  code?: Maybe<Scalars['String']['output']>;
  displayFormat?: Maybe<Scalars['String']['output']>;
  displayType?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  mediaCategories?: Maybe<Array<MediaCategory>>;
  mediaGroups?: Maybe<MediaGroupResponse>;
  mediaHeight?: Maybe<Scalars['Int']['output']>;
  mediaInfo?: Maybe<MediaInfo>;
  mediaInstall?: Maybe<MediaInstall>;
  mediaPeripheralInfos?: Maybe<Array<MediaPeripheralInfo>>;
  mediaProducts?: Maybe<MediaProductResponse>;
  mediaSize?: Maybe<Scalars['Float']['output']>;
  mediaTags?: Maybe<Array<MediaTag>>;
  mediaWidth?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organizationsInfoId?: Maybe<Scalars['Int']['output']>;
  pitch?: Maybe<Scalars['Int']['output']>;
  resolutionHeight?: Maybe<Scalars['Int']['output']>;
  resolutionType?: Maybe<Scalars['String']['output']>;
  resolutionWidth?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  trafficValue?: Maybe<Scalars['Float']['output']>;
};

export type MediaCategory = {
  __typename?: 'MediaCategory';
  code?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  mediaCategoryName?: Maybe<Scalars['String']['output']>;
  parentCd?: Maybe<Scalars['String']['output']>;
};

export type MediaGroup = {
  __typename?: 'MediaGroup';
  code?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  mediaInstallSiteCd?: Maybe<Scalars['Int']['output']>;
  mediaProducts?: Maybe<MediaProductResponse>;
  medias?: Maybe<MediasResponse>;
  name?: Maybe<Scalars['String']['output']>;
  operationDays?: Maybe<Scalars['String']['output']>;
  organizationsInfoId?: Maybe<Scalars['Int']['output']>;
  serviceMaxPlayTime?: Maybe<Scalars['Int']['output']>;
  serviceSlot?: Maybe<Scalars['Int']['output']>;
  serviceTimeFrom?: Maybe<Scalars['String']['output']>;
  serviceTimeTo?: Maybe<Scalars['String']['output']>;
};

export type MediaGroupResponse = {
  __typename?: 'MediaGroupResponse';
  mediaGroups?: Maybe<Array<MediaGroup>>;
  paging?: Maybe<Paging>;
};

export type MediaInfo = {
  __typename?: 'MediaInfo';
  baseAddress?: Maybe<Scalars['String']['output']>;
  baseAddressKr?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  cityCode?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  detailAddress?: Maybe<Scalars['String']['output']>;
  district?: Maybe<Scalars['String']['output']>;
  districtCode?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  mediaId?: Maybe<Scalars['Int']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type MediaInstall = {
  __typename?: 'MediaInstall';
  installDate?: Maybe<Scalars['String']['output']>;
  mediaId?: Maybe<Scalars['Int']['output']>;
  mediaInstallFile?: Maybe<Scalars['Int']['output']>;
  mediaInstallId: Scalars['Int']['output'];
  mediaInstallPlaceSite?: Maybe<Scalars['String']['output']>;
  modifyDate?: Maybe<Scalars['String']['output']>;
};

export type MediaPeripheralInfo = {
  __typename?: 'MediaPeripheralInfo';
  id: Scalars['Int']['output'];
  mediaId?: Maybe<Scalars['Int']['output']>;
  peripheralCd?: Maybe<Scalars['String']['output']>;
};

export type MediaProduct = {
  __typename?: 'MediaProduct';
  adServiceInfos?: Maybe<Array<AdServiceInfo>>;
  bannerId?: Maybe<Scalars['String']['output']>;
  bannerPath?: Maybe<Scalars['String']['output']>;
  bannerUrl?: Maybe<Scalars['String']['output']>;
  baseAddress?: Maybe<Scalars['String']['output']>;
  createdByUserId?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  fileGuidePath?: Maybe<Scalars['String']['output']>;
  fileGuideUrl?: Maybe<Scalars['String']['output']>;
  guideFileId?: Maybe<Scalars['String']['output']>;
  guideFileInfoId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  isMyBookmark: Scalars['Boolean']['output'];
  mediaCategoryId?: Maybe<Scalars['String']['output']>;
  mediaGroups?: Maybe<MediaGroupResponse>;
  metaDeactivated?: Maybe<Scalars['String']['output']>;
  modifiedByUserId?: Maybe<Scalars['Int']['output']>;
  modifyDate?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organizationsInfoId?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type MediaProductResponse = {
  __typename?: 'MediaProductResponse';
  paging?: Maybe<Paging>;
  products?: Maybe<Array<MediaProduct>>;
};

export type MediaTag = {
  __typename?: 'MediaTag';
  mediaTagDetailId?: Maybe<Scalars['Int']['output']>;
  mediaTagId: Scalars['Int']['output'];
};

export type MediasResponse = {
  __typename?: 'MediasResponse';
  medias?: Maybe<Array<Media>>;
  paging?: Maybe<Paging>;
};

export type Mutation = {
  __typename?: 'Mutation';
  clearMediaProductsCache: Scalars['String']['output'];
};

export type Paging = {
  __typename?: 'Paging';
  page?: Maybe<Scalars['Int']['output']>;
  pageSize?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type Query = {
  __typename?: 'Query';
  
  mediaProductsInBounds: MediaProductResponse;
  mediasInBounds: MediasResponse;
};


export type QueryMediaProductsInBoundsArgs = {
  adFeePerMonth?: InputMaybe<Scalars['Int']['input']>;
  adTypes?: InputMaybe<Scalars['String']['input']>;
  bounds?: InputMaybe<Bounds>;
  inAge?: InputMaybe<Array<AgeGroup>>;
  inGender?: InputMaybe<Array<Gender>>;
  isMyBookmark?: InputMaybe<Scalars['Boolean']['input']>;
  isMyProduct?: InputMaybe<Scalars['Boolean']['input']>;
  mediaGroupId?: InputMaybe<Scalars['String']['input']>;
  mediaId?: InputMaybe<Scalars['String']['input']>;
  mediaProductId?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  targetCategories?: InputMaybe<Scalars['String']['input']>;
  targetTypes?: InputMaybe<Scalars['String']['input']>;
  trafficValue?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMediasInBoundsArgs = {
  adFeePerMonth?: InputMaybe<Scalars['Int']['input']>;
  adTypes?: InputMaybe<Scalars['String']['input']>;
  bounds?: InputMaybe<Bounds>;
  inAge?: InputMaybe<Array<AgeGroup>>;
  inGender?: InputMaybe<Array<Gender>>;
  isMyBookmark?: InputMaybe<Scalars['Boolean']['input']>;
  isMyProduct?: InputMaybe<Scalars['Boolean']['input']>;
  mediaGroupId?: InputMaybe<Scalars['String']['input']>;
  mediaId?: InputMaybe<Scalars['String']['input']>;
  mediaProductId?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  targetCategories?: InputMaybe<Scalars['String']['input']>;
  targetTypes?: InputMaybe<Scalars['String']['input']>;
  trafficValue?: InputMaybe<Scalars['Int']['input']>;
};

export type GetMediaProductsInBoundsQueryVariables = Exact<{
  bounds?: InputMaybe<Bounds>;
  isMyProduct: Scalars['Boolean']['input'];
  targetCategories?: InputMaybe<Scalars['String']['input']>;
  targetTypes?: InputMaybe<Scalars['String']['input']>;
  trafficValue?: InputMaybe<Scalars['Int']['input']>;
  inGender?: InputMaybe<Array<Gender> | Gender>;
  inAge?: InputMaybe<Array<AgeGroup> | AgeGroup>;
  isMyBookmark?: InputMaybe<Scalars['Boolean']['input']>;
  adFeePerMonth?: InputMaybe<Scalars['Int']['input']>;
  adTypes?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetMediaProductsInBoundsQuery = { __typename?: 'Query', mediaProductsInBounds: { __typename?: 'MediaProductResponse', products?: Array<{ __typename?: 'MediaProduct', id: number, bannerId?: string | null, bannerUrl?: string | null, baseAddress?: string | null, mediaCategoryId?: string | null, name?: string | null, isMyBookmark: boolean, adServiceInfos?: Array<{ __typename?: 'AdServiceInfo', adServiceOptions?: Array<{ __typename?: 'AdServiceOption', adFeePerMonth?: number | null, isDefaultOption?: boolean | null, adType?: string | null }> | null }> | null, mediaGroups?: { __typename?: 'MediaGroupResponse', mediaGroups?: Array<{ __typename?: 'MediaGroup', name?: string | null, serviceSlot?: number | null, serviceMaxPlayTime?: number | null, medias?: { __typename?: 'MediasResponse', medias?: Array<{ __typename?: 'Media', displayType?: string | null, displayFormat?: string | null, mediaWidth?: number | null, mediaSize?: number | null, mediaHeight?: number | null, resolutionHeight?: number | null, resolutionType?: string | null, resolutionWidth?: number | null, trafficValue?: number | null, pitch?: number | null, mediaInfo?: { __typename?: 'MediaInfo', lat?: number | null, lng?: number | null } | null, mediaCategories?: Array<{ __typename?: 'MediaCategory', id: string, mediaCategoryName?: string | null, parentCd?: string | null }> | null }> | null } | null }> | null } | null }> | null }, mediasInBounds: { __typename?: 'MediasResponse', medias?: Array<{ __typename?: 'Media', id: number, name?: string | null, displayType?: string | null, trafficValue?: number | null, mediaInfo?: { __typename?: 'MediaInfo', lat?: number | null, lng?: number | null, id: number, mediaId?: number | null } | null, mediaCategories?: Array<{ __typename?: 'MediaCategory', mediaCategoryName?: string | null, id: string, icon?: string | null, parentCd?: string | null }> | null, mediaProducts?: { __typename?: 'MediaProductResponse', products?: Array<{ __typename?: 'MediaProduct', id: number, name?: string | null, adServiceInfos?: Array<{ __typename?: 'AdServiceInfo', adServiceOptions?: Array<{ __typename?: 'AdServiceOption', isDefaultOption?: boolean | null, adFeePerMonth?: number | null }> | null }> | null }> | null } | null }> | null } };


export const GetMediaProductsInBoundsDocument = gql`
    query GetMediaProductsInBounds($bounds: Bounds, $isMyProduct: Boolean!, $targetCategories: String, $targetTypes: String, $trafficValue: Int, $inGender: [Gender!], $inAge: [AgeGroup!], $isMyBookmark: Boolean, $adFeePerMonth: Int, $adTypes: String) {
  mediaProductsInBounds(
    bounds: $bounds
    isMyProduct: $isMyProduct
    targetCategories: $targetCategories
    targetTypes: $targetTypes
    trafficValue: $trafficValue
    inGender: $inGender
    inAge: $inAge
    isMyBookmark: $isMyBookmark
    adFeePerMonth: $adFeePerMonth
    adTypes: $adTypes
  ) {
    products {
      id
      bannerId
      bannerUrl
      baseAddress
      mediaCategoryId
      name
      isMyBookmark
      adServiceInfos {
        adServiceOptions {
          adFeePerMonth
          isDefaultOption
          adType
        }
      }
      mediaGroups {
        mediaGroups {
          name
          serviceSlot
          serviceMaxPlayTime
          medias {
            medias {
              displayType
              displayFormat
              mediaWidth
              mediaSize
              mediaHeight
              resolutionHeight
              resolutionType
              resolutionWidth
              trafficValue
              mediaInfo {
                lat
                lng
              }
              pitch
              mediaCategories {
                id
                mediaCategoryName
                parentCd
              }
            }
          }
        }
      }
    }
  }
  mediasInBounds(
    bounds: $bounds
    isMyProduct: $isMyProduct
    targetCategories: $targetCategories
    targetTypes: $targetTypes
    trafficValue: $trafficValue
    inGender: $inGender
    inAge: $inAge
    isMyBookmark: $isMyBookmark
    adFeePerMonth: $adFeePerMonth
    adTypes: $adTypes
  ) {
    medias {
      id
      name
      mediaInfo {
        lat
        lng
        id
        mediaId
      }
      mediaCategories {
        mediaCategoryName
        id
        icon
        parentCd
      }
      mediaProducts {
        products {
          id
          name
          adServiceInfos {
            adServiceOptions {
              isDefaultOption
              adFeePerMonth
            }
          }
        }
      }
      displayType
      trafficValue
    }
  }
}
    `;

/**
 * __useGetMediaProductsInBoundsQuery__
 *
 * To run a query within a React component, call `useGetMediaProductsInBoundsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMediaProductsInBoundsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMediaProductsInBoundsQuery({
 *   variables: {
 *      bounds: // value for 'bounds'
 *      isMyProduct: // value for 'isMyProduct'
 *      targetCategories: // value for 'targetCategories'
 *      targetTypes: // value for 'targetTypes'
 *      trafficValue: // value for 'trafficValue'
 *      inGender: // value for 'inGender'
 *      inAge: // value for 'inAge'
 *      isMyBookmark: // value for 'isMyBookmark'
 *      adFeePerMonth: // value for 'adFeePerMonth'
 *      adTypes: // value for 'adTypes'
 *   },
 * });
 */
export function useGetMediaProductsInBoundsQuery(baseOptions: Apollo.QueryHookOptions<GetMediaProductsInBoundsQuery, GetMediaProductsInBoundsQueryVariables> & ({ variables: GetMediaProductsInBoundsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMediaProductsInBoundsQuery, GetMediaProductsInBoundsQueryVariables>(GetMediaProductsInBoundsDocument, options);
      }
export function useGetMediaProductsInBoundsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMediaProductsInBoundsQuery, GetMediaProductsInBoundsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMediaProductsInBoundsQuery, GetMediaProductsInBoundsQueryVariables>(GetMediaProductsInBoundsDocument, options);
        }
export function useGetMediaProductsInBoundsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMediaProductsInBoundsQuery, GetMediaProductsInBoundsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMediaProductsInBoundsQuery, GetMediaProductsInBoundsQueryVariables>(GetMediaProductsInBoundsDocument, options);
        }
export type GetMediaProductsInBoundsQueryHookResult = ReturnType<typeof useGetMediaProductsInBoundsQuery>;
export type GetMediaProductsInBoundsLazyQueryHookResult = ReturnType<typeof useGetMediaProductsInBoundsLazyQuery>;
export type GetMediaProductsInBoundsSuspenseQueryHookResult = ReturnType<typeof useGetMediaProductsInBoundsSuspenseQuery>;
export type GetMediaProductsInBoundsQueryResult = Apollo.QueryResult<GetMediaProductsInBoundsQuery, GetMediaProductsInBoundsQueryVariables>;